'use strict';

angular.module('welcomeModule')

.config(function ($stateProvider)
{
    $stateProvider
    .state('admin.welcome', {
        url: '/welcome',
        templateUrl: 'welcome/welcome.html',
    });
});
